<template>
    <Drawer
        ref="drawer"
        title="OCR Document Upload"
        :loading="isLoading || isUpdating"
        header-class="p-0 border-0"
        size="is-large"
        @closed="resetDrawer()"
    >
        <template #header></template>
        <DrawerFilesTab
            class="tw-mt-5 tw-mx-3"
            :endpoint="route('api.account.ocr.upload')"
            :complete-endpoint="route('api.account.ocr.completeUpload')"
            :files="files"
            :show-files="false"
            :disabled="false"
            @updated="documentCallback"
            @uploaded="documentUploaded"
        />
        <div class="tw-grid tw-gap-4 tw-m-4">
            <OCRDocument v-for="document in files" :key="document.id" :doc="document" />
        </div>
        <template #footer></template>
    </Drawer>
</template>
<script setup>
import Drawer from '@/js/components/Drawer.vue';
import { useDataStore } from '@/js/stores/DataStore.js';
import { onMounted, ref, useTemplateRef } from 'vue';
import DrawerFilesTab from '@/assets/js/eventbooks/components/drawer-tabs/files.vue';
import { sockets } from '@/js/composables/useSockets.js';
import OCRDocument from '@/js/components/widgets/OCRDocument.vue';
import { capturePosthogEvent } from '@/js/composables/usePosthog.js';

const store = useDataStore();
const drawer = useTemplateRef('drawer');
const files = ref([]);

const isLoading = ref(false);
const isUpdating = ref(false);

onMounted(() => {
    Eventbus.$on('openOCRImport', () => {
        openDrawer();
        loadFiles();

        sockets.joinChannel(`Account.${store.account.id}`).listen('.ocr', (data) => {
            if (data.document_id && data.document_id !== 0) {
                const existingDocument = files.value.find((doc) => doc.id === data.document_id);
                if (existingDocument) {
                    if (data.status === 'COMPLETED') {
                        files.value = files.value.filter((doc) => doc.id !== data.document_id);
                        return;
                    }

                    existingDocument.status = data.status;
                    if (Object.hasOwn(data, 'progress')) {
                        existingDocument.status_progress = data.progress ? { ...data.progress } : null;
                    }
                }
            }
        });
    });
});

const loadFiles = async () => {
    isLoading.value = true;
    try {
        const response = await axios.get(route('api.account.ocr.list'));
        files.value = response.data.data;
    } catch {
    } finally {
        isLoading.value = false;
    }
};

const documentCallback = (data) => {
    files.value.unshift(data.data);
};

const documentUploaded = () => {
    capturePosthogEvent('ocr_invoice_uploaded');
};

const openDrawer = () => {
    drawer.value?.open();
};

const resetDrawer = () => {
    isLoading.value = false;
};
</script>
